import React from "react";
import InfoTooltip from "./InfoTooltip";

type InputPrefixWrapperProps = {
  label: string;
  tooltipText?: string;
  children: React.ReactNode;
};
export default function InputPrefixWrapper({
  label,
  tooltipText,
  children,
}: InputPrefixWrapperProps) {
  return (
    <div className="items-center text-sm border rounded-md focus-within:ring-1 focus-within:ring-primary-0 grid grid-cols-2">
      <div className="flex items-center flex-shrink-0 px-4 py-3 text-muted-foreground bg-secondary rounded-tl-md rounded-bl-md">
        {label}
        {tooltipText && <InfoTooltip text={tooltipText} />}
      </div>
      <div className="w-full h-full">{children}</div>
    </div>
  );
}
